import VocaStudyCard from "./VocaStudyCard";
import { useTTS } from "../../../../../hooks/useTTS";

const VocaStudyPage = ({ currentPage, setPageList, currentIndex }) => {
  const { speak } = useTTS();

  const handleFlip = (clickedWord) => {
    speak({ text: clickedWord.eng });
    setPageList((prevPageList) => {
      return prevPageList.map((page, pageIndex) => {
        if (pageIndex === currentIndex) {
          return {
            ...page,
            data: page.data.map((word) => {
              if (word.eng === clickedWord.eng) {
                return { ...word, isOpened: !word.isOpened };
              }
              return word;
            }),
          };
        }
        return page;
      });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        // 화살표 사이에 낀 본문이라 폭을 스스로 가져야 한다. 없으면 flex 줄에서
        // 내용물 최소폭(break-word 라 글자 1개)까지 쪼그라들어 카드가 세로
        // 슬리버로 부서졌다 (2026-08-27, 빌드마다 CSS 순서 따라 됐다 안 됐다 함).
        flex: 1,
        minWidth: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          gap: Math.min(window.innerWidth, window.screen.width) <= 768 ? "6px" : "12px", // [원본 유지 + 폰 간격만]
        }}
      >
        {currentPage.data.slice(0, 5).map((word) => {
          return (
            <VocaStudyCard key={word.eng} word={word} handleFlip={handleFlip} />
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          gap: Math.min(window.innerWidth, window.screen.width) <= 768 ? "6px" : "12px", // [원본 유지 + 폰 간격만]
        }}
      >
        {currentPage.data.slice(5).map((word) => {
          return (
            <VocaStudyCard key={word.eng} word={word} handleFlip={handleFlip} />
          );
        })}
      </div>
    </div>
  );
};

export default VocaStudyPage;
